var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var StyledIframe = styled.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: auto;\n  min-height: 723px;\n  position: relative;\n  width: calc(100% + 30px);\n  margin: 20px 0 0 -15px;\n"], ["\n  height: auto;\n  min-height: 723px;\n  position: relative;\n  width: calc(100% + 30px);\n  margin: 20px 0 0 -15px;\n"])));
var templateObject_1;
